<!-- Seat-budget banner: shows current usage and disables the form when the
     org has run out of seats on its active subscription. Only rendered in
     create mode (skipped while editing an existing user). -->
<div
  *ngIf="!userId && seatBudget"
  class="seat-budget-banner"
  [class.seat-budget-banner--exceeded]="seatBudget.limitExceeded"
>
  <div class="seat-budget-banner__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-5a4 4 0 11-8 0 4 4 0 018 0zm6 0a3 3 0 11-6 0 3 3 0 016 0z"/>
    </svg>
  </div>
  <div class="seat-budget-banner__body">
    <div class="seat-budget-banner__title">
      <ng-container *ngIf="seatBudget.limitExceeded; else withinTpl">
        Seat limit reached — {{ seatBudget.consumed }} / {{ seatBudget.cap }}
      </ng-container>
      <ng-template #withinTpl>
        Seats in use: {{ seatBudget.consumed }} / {{ seatBudget.cap }}
        <span class="seat-budget-banner__remaining">
          ({{ seatBudget.remaining }} remaining)
        </span>
      </ng-template>
    </div>
    <p class="seat-budget-banner__message">{{ seatBudget.message }}</p>
  </div>
  <a
    *ngIf="seatBudget.limitExceeded"
    class="seat-budget-banner__cta"
    routerLink="/home/subscription"
  >
    Manage subscription
  </a>
</div>

<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step [stepControl]="vendorForm" >
    <!-- <form [formGroup]="vendorForm">
      <ng-template matStepLabel>vendor</ng-template>

      <div class="form-row">
          <div class="half-width" *ngIf="branchShow">
          <mat-label>Branch <span class="red">*</span></mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="branch_id">
              <mat-option value="">Select Branch</mat-option>
               <mat-option *ngFor="let branch of branchList" [value]="branch.branch_id">{{ branch.branch_name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="vendorForm.get('branch_id')?.hasError('required')">
              Branch is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>User Type <span class="red">*</span></mat-label>
          <mat-form-field appearance="outline">
            <mat-select formControlName="userType">
              <mat-option value="Vendor">Vendor</mat-option>
              <mat-option value="Supplier">Supplier</mat-option>
              <mat-option value="Partner">Partner</mat-option>
            </mat-select>
            <mat-error *ngIf="vendorForm.get('userType')?.hasError('required')">
              User type is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Vendor Name<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="vendorName" />
            <mat-error *ngIf="vendorForm.get('vendorName')?.hasError('required')">
              Vendor name is required
            </mat-error>
          </mat-form-field>
        </div>

      </div>
      <div class="form-row">
        <div class="half-width">
          <mat-label>Full Name<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="fullName" />
            <mat-error *ngIf="vendorForm.get('fullName')?.hasError('required')">
              Full name is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">

          <mat-label>Email<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="email" />
            <mat-error *ngIf="vendorForm.get('email')?.hasError('required')">Email is required</mat-error>
            <mat-error *ngIf="vendorForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row" *ngIf="!this.userId">
        <div class="half-width">
          <mat-label>Password<span class="red">*</span></mat-label>
          <mat-form-field appearance="outline">
            <input matInput formControlName="password" type="password" />
            <mat-error *ngIf="vendorForm.get('password')?.hasError('required')">
              Password is required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">

          <mat-label>Industry Type<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="industryType" />
            <mat-error *ngIf="vendorForm.get('industryType')?.hasError('required')">
              Industry type is required
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="form-row">
        <div class="half-width">

          <mat-label>Primary Phone<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="primaryPhone" />
            <mat-error *ngIf="vendorForm.get('primaryPhone')?.hasError('required')">Primary phone is
              required</mat-error>
            <mat-error *ngIf="vendorForm.get('primaryPhone')?.hasError('pattern')">Invalid phone number</mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">

          <mat-label>Alternative Phone<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="alternativePhone" />
            <mat-error *ngIf="vendorForm.get('alternativePhone')?.hasError('required')">Alternative phone is
              required</mat-error>
            <mat-error *ngIf="vendorForm.get('alternativePhone')?.hasError('pattern')">Invalid phone number</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <mat-label>Website<span class="red">*</span></mat-label>

        <mat-form-field appearance="outline">
          <input matInput formControlName="website" />
          <mat-error *ngIf="vendorForm.get('website')?.hasError('required')">Website is required</mat-error>
          <mat-error *ngIf="vendorForm.get('website')?.hasError('pattern')">Enter a valid URL</mat-error>
        </mat-form-field>
      </div>
      <div class="form-actions">
        <button mat-raised-button color="primary" matStepperNext [disabled]="!vendorForm.valid">Next</button>
      </div>
    </form> -->
    <form [formGroup]="vendorForm">
      <ng-template matStepLabel>{{ "VENDOR_NAME" | translate }}</ng-template>

      <div class="form-row">
        <div class="half-width" *ngIf="branchShow">
          <mat-label
            >{{ "BRANCH" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <mat-select formControlName="branch_id">
              <mat-option value="">{{
                "SELECT_BRANCH" | translate
              }}</mat-option>
              <mat-option
                *ngFor="let branch of branchList"
                [value]="branch.branch_id"
              >
                {{ branch.branch_name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="vendorForm.get('branch_id')?.hasError('required')"
            >
              {{ "BRANCH" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label
            >{{ "USER_TYPE" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <mat-select formControlName="userType">
              <mat-option value="Vendor">{{ "VENDOR" | translate }}</mat-option>
              <mat-option value="Supplier">{{
                "SUPPLIER" | translate
              }}</mat-option>
              <mat-option value="Partner">{{
                "PARTNER" | translate
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="vendorForm.get('userType')?.hasError('required')">
              {{ "USER_TYPE" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label
            >{{ "VENDOR_NAME" | translate }}
            <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="vendorName" />
            <mat-error
              *ngIf="vendorForm.get('vendorName')?.hasError('required')"
            >
              {{ "VENDOR_NAME" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="half-width">
          <mat-label
            >{{ "FULL_NAME" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="fullName" />
            <mat-error *ngIf="vendorForm.get('fullName')?.hasError('required')">
              {{ "FULL_NAME" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label
            >{{ "EMAIL" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="email" />
            <mat-error *ngIf="vendorForm.get('email')?.hasError('required')">
              {{ "EMAIL" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
            <mat-error *ngIf="vendorForm.get('email')?.hasError('email')">
              {{ "INVALID_EMAIL" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row" *ngIf="!this.userId">
        <div class="half-width">
          <mat-label
            >{{ "PASSWORD" | translate }} <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="password" type="password" />
            <mat-error *ngIf="vendorForm.get('password')?.hasError('required')">
              {{ "PASSWORD" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label
            >{{ "INDUSTRY_TYPE" | translate }}
            <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="industryType" />
            <mat-error
              *ngIf="vendorForm.get('industryType')?.hasError('required')"
            >
              {{ "INDUSTRY_TYPE" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <div class="half-width">
          <mat-label
            >{{ "PRIMARY_PHONE" | translate }}
            <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="primaryPhone" />
            <mat-error
              *ngIf="vendorForm.get('primaryPhone')?.hasError('required')"
            >
              {{ "PRIMARY_PHONE" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
            <mat-error
              *ngIf="vendorForm.get('primaryPhone')?.hasError('pattern')"
            >
              {{ "INVALID_PHONE" | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="half-width">
          <mat-label
            >{{ "ALTERNATIVE_PHONE" | translate }}
            <span class="red">*</span></mat-label
          >
          <mat-form-field appearance="outline">
            <input matInput formControlName="alternativePhone" />
            <mat-error
              *ngIf="vendorForm.get('alternativePhone')?.hasError('required')"
            >
              {{ "ALTERNATIVE_PHONE" | translate }} {{ "REQUIRED" | translate }}
            </mat-error>
            <mat-error
              *ngIf="vendorForm.get('alternativePhone')?.hasError('pattern')"
            >
              {{ "INVALID_PHONE" | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="form-row">
        <mat-label
          >{{ "WEBSITE" | translate }} <span class="red">*</span></mat-label
        >
        <mat-form-field appearance="outline">
          <input matInput formControlName="website" />
          <mat-error *ngIf="vendorForm.get('website')?.hasError('required')">
            {{ "WEBSITE" | translate }} {{ "REQUIRED" | translate }}
          </mat-error>
          <mat-error *ngIf="vendorForm.get('website')?.hasError('pattern')">
            {{ "INVALID_URL" | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-actions">
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!vendorForm.valid"
        >
          {{ "NEXT" | translate }}
        </button>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="contractorsForm" >
    <!-- <form [formGroup]="contractorsForm">
      <ng-template matStepLabel>Contractors & Vendors</ng-template>

      <mat-accordion>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Main Contractor</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Company Name<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="mainContractorName" />
                <mat-error *ngIf="contractorsForm.get('mainContractorName')?.hasError('required')">Required</mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label>Registration/License Number<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="mainContractorLicense" />
                <mat-error
                  *ngIf="contractorsForm.get('mainContractorLicense')?.hasError('required')">Required</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="half-width">
              <mat-label>CPWD/PWD Category<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="mainContractorCategory" />
                <mat-error
                  *ngIf="contractorsForm.get('mainContractorCategory')?.hasError('required')">Required</mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Contact Information<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="mainContractorContact"></textarea>
                <mat-error
                  *ngIf="contractorsForm.get('mainContractorContact')?.hasError('required')">Required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="half-width">
              <mat-label>Performance History</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="performanceHistory"></textarea>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Bank Guarantee Details</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="bankGuarantee"></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Subcontractors</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Scope of Work</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="subcontractScope"></textarea>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Company Details</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="subcontractCompany"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="half-width">
            <mat-label>Contact Information</mat-label>

            <mat-form-field class="full-width" appearance="outline">
              <textarea matInput formControlName="subcontractContact"></textarea>
            </mat-form-field>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Material Suppliers</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Material Type<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="materialType" />
                <mat-error *ngIf="contractorsForm.get('materialType')?.hasError('required')">Required</mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Supplier Name<span class="red">*</span></mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="supplierName" />
                <mat-error *ngIf="contractorsForm.get('supplierName')?.hasError('required')">Required</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="form-row">
            <div class="half-width">
              <mat-label>Quality Certifications (BIS, etc.)</mat-label>

              <mat-form-field appearance="outline">
                <input matInput formControlName="qualityCertifications" />
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Contact Information</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="supplierContact"></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Approved Sources</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label>Quarry Locations</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="quarryLocations"></textarea>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>Borrow Area Details</mat-label>

              <mat-form-field appearance="outline">
                <textarea matInput formControlName="borrowDetails"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="half-width">
            <mat-label>Royalty Payment Status</mat-label>

            <mat-form-field class="full-width" appearance="outline">
              <textarea matInput formControlName="royaltyStatus"></textarea>
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="form-actions">
        <button mat-button matStepperPrevious>Back</button>
        <button mat-raised-button color="primary" matStepperNext [disabled]="!contractorsForm.valid">Next</button>
      </div>
    </form> -->
    <form [formGroup]="contractorsForm">
      <ng-template matStepLabel>{{
        "contractors.step_label" | translate
      }}</ng-template>

      <mat-accordion>
        <!-- Main Contractor -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "contractors.main_title" | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label
                >{{ "contractors.company_name" | translate
                }}<span class="red">*</span></mat-label
              >
              <mat-form-field appearance="outline">
                <input matInput formControlName="mainContractorName" />
                <mat-error
                  *ngIf="
                    contractorsForm
                      .get('mainContractorName')
                      ?.hasError('required')
                  "
                >
                  {{ "error.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="half-width">
              <mat-label
                >{{ "contractors.license" | translate
                }}<span class="red">*</span></mat-label
              >
              <mat-form-field appearance="outline">
                <input matInput formControlName="mainContractorLicense" />
                <mat-error
                  *ngIf="
                    contractorsForm
                      .get('mainContractorLicense')
                      ?.hasError('required')
                  "
                >
                  {{ "error.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="half-width">
              <mat-label
                >{{ "contractors.category" | translate
                }}<span class="red">*</span></mat-label
              >
              <mat-form-field appearance="outline">
                <input matInput formControlName="mainContractorCategory" />
                <mat-error
                  *ngIf="
                    contractorsForm
                      .get('mainContractorCategory')
                      ?.hasError('required')
                  "
                >
                  {{ "error.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label
                >{{ "contractors.contact_info" | translate
                }}<span class="red">*</span></mat-label
              >
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  formControlName="mainContractorContact"
                ></textarea>
                <mat-error
                  *ngIf="
                    contractorsForm
                      .get('mainContractorContact')
                      ?.hasError('required')
                  "
                >
                  {{ "error.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="half-width">
              <mat-label>{{ "contractors.performance" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  formControlName="performanceHistory"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{
                "contractors.bank_guarantee" | translate
              }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea matInput formControlName="bankGuarantee"></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Subcontractors -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "contractors.subcontractors" | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label>{{ "contractors.scope" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  formControlName="subcontractScope"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{
                "contractors.company_details" | translate
              }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea
                  matInput
                  formControlName="subcontractCompany"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="half-width">
            <mat-label>{{ "contractors.contact_info" | translate }}</mat-label>
            <mat-form-field class="full-width" appearance="outline">
              <textarea
                matInput
                formControlName="subcontractContact"
              ></textarea>
            </mat-form-field>
          </div>
        </mat-expansion-panel>

        <!-- Material Suppliers -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "contractors.suppliers" | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label
                >{{ "contractors.material_type" | translate
                }}<span class="red">*</span></mat-label
              >
              <mat-form-field appearance="outline">
                <input matInput formControlName="materialType" />
                <mat-error
                  *ngIf="
                    contractorsForm.get('materialType')?.hasError('required')
                  "
                >
                  {{ "error.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label
                >{{ "contractors.supplier_name" | translate
                }}<span class="red">*</span></mat-label
              >
              <mat-form-field appearance="outline">
                <input matInput formControlName="supplierName" />
                <mat-error
                  *ngIf="
                    contractorsForm.get('supplierName')?.hasError('required')
                  "
                >
                  {{ "error.required" | translate }}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-row">
            <div class="half-width">
              <mat-label>{{
                "contractors.certifications" | translate
              }}</mat-label>
              <mat-form-field appearance="outline">
                <input matInput formControlName="qualityCertifications" />
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{
                "contractors.contact_info" | translate
              }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea matInput formControlName="supplierContact"></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <!-- Approved Sources -->
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{
              "contractors.sources" | translate
            }}</mat-panel-title>
          </mat-expansion-panel-header>

          <div class="form-row">
            <div class="half-width">
              <mat-label>{{ "contractors.quarry" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea matInput formControlName="quarryLocations"></textarea>
              </mat-form-field>
            </div>
            <div class="half-width">
              <mat-label>{{ "contractors.borrow" | translate }}</mat-label>
              <mat-form-field appearance="outline">
                <textarea matInput formControlName="borrowDetails"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div class="half-width">
            <mat-label>{{ "contractors.royalty" | translate }}</mat-label>
            <mat-form-field class="full-width" appearance="outline">
              <textarea matInput formControlName="royaltyStatus"></textarea>
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <div class="form-actions">
        <button mat-button matStepperPrevious>
          {{ "button.back" | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!contractorsForm.valid"
        >
          {{ "button.next" | translate }}
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="indianSpecificForm" >
    <form [formGroup]="indianSpecificForm">
  <ng-template matStepLabel>{{ 'indian.step_label' | translate }}</ng-template>

  <h3>{{ 'indian.heading_gst' | translate }}</h3>
  <div class="form-row">
    <div class="half-width">
      <mat-label>{{ 'indian.gst_details' | translate }}<span class="red">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="gstDetails" />
        <mat-error *ngIf="indianSpecificForm.get('gstDetails')?.hasError('required')">
          {{ 'error.required' | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.tax_deduction' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="taxDeduction" />
      </mat-form-field>
    </div>
  </div>

  <h3>{{ 'indian.heading_labour' | translate }}</h3>
  <div class="form-row">
    <div class="half-width">
      <mat-label>{{ 'indian.labour_license' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="labourLicense" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.workmen_insurance' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="workmenInsurance" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.pf_esi' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="pfEsi" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.labour_welfare' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput formControlName="labourWelfare"></textarea>
      </mat-form-field>
    </div>
  </div>

  <h3>{{ 'indian.heading_contract_type' | translate }}</h3>
  <div class="half-width">
    <mat-label>{{ 'indian.contract_type' | translate }}<span class="red">*</span></mat-label>
    <mat-form-field class="full-width" appearance="outline">
      <mat-select formControlName="contractType" required>
        <mat-option value="EPC">EPC</mat-option>
        <mat-option value="Item Rate">{{ 'indian.item_rate' | translate }}</mat-option>
        <mat-option value="BOT/DBFOT">BOT/DBFOT</mat-option>
        <mat-option value="HAM">HAM</mat-option>
      </mat-select>
      <mat-error *ngIf="indianSpecificForm.get('contractType')?.hasError('required')">
        {{ 'error.required' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <h3>{{ 'indian.heading_dispute' | translate }}</h3>
  <div class="form-row">
    <div class="half-width">
      <mat-label>{{ 'indian.arbitration' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="arbitration" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.conciliation' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="conciliation" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.dispute_board' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="disputeBoard" />
      </mat-form-field>
    </div>
  </div>

  <h3>{{ 'indian.heading_local_content' | translate }}</h3>
  <div class="form-row">
    <div class="half-width">
      <mat-label>{{ 'indian.make_in_india' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="makeInIndia" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.msme_participation' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="msmeParticipation" />
      </mat-form-field>
    </div>
  </div>

  <h3>{{ 'indian.heading_maintenance' | translate }}</h3>
  <div class="form-row">
    <div class="half-width">
      <mat-label>{{ 'indian.defect_liability' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="defectLiability" />
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.routine_maintenance' | translate }}</mat-label>
      <mat-form-field appearance="outline">
        <textarea matInput formControlName="routineMaintenance"></textarea>
      </mat-form-field>
    </div>
    <div class="half-width">
      <mat-label>{{ 'indian.performance_maintenance' | translate }}</mat-label>
      <mat-form-field class="full-width" appearance="outline">
        <textarea matInput formControlName="performanceMaintenance"></textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="form-actions">
    <button mat-button matStepperPrevious>{{ 'button.back' | translate }}</button>
    <button mat-raised-button color="primary" matStepperNext [disabled]="!indianSpecificForm.valid">
      {{ 'button.next' | translate }}
    </button>
  </div>
</form>

    <!-- <form [formGroup]="indianSpecificForm">
      <ng-template matStepLabel>Indian-Specific Requirements</ng-template>

      <h3>GST Compliance</h3>
      <div class="form-row">
        <div class="half-width">
          <mat-label
            >GST Registration Details<span class="red">*</span></mat-label
          >

          <mat-form-field appearance="outline">
            <input matInput formControlName="gstDetails" />
            <mat-error
              *ngIf="indianSpecificForm.get('gstDetails')?.hasError('required')"
            >
              Required
            </mat-error>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Tax Deduction Requirements</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="taxDeduction" />
          </mat-form-field>
        </div>
      </div>

      <h3>Labour Compliance</h3>
      <div class="form-row">
        <div class="half-width">
          <mat-label>Labour License</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="labourLicense" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Workmen Compensation Insurance</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="workmenInsurance" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>PF/ESI Registration</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="pfEsi" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Labour Welfare Provisions</mat-label>

          <mat-form-field appearance="outline">
            <textarea matInput formControlName="labourWelfare"></textarea>
          </mat-form-field>
        </div>
      </div>

      <h3>Contract Type</h3>
      <div class="half-width">
        <mat-label>Contract Type<span class="red">*</span></mat-label>

        <mat-form-field class="full-width" appearance="outline">
          <mat-select formControlName="contractType" required>
            <mat-option value="EPC">EPC</mat-option>
            <mat-option value="Item Rate">Item Rate</mat-option>
            <mat-option value="BOT/DBFOT">BOT/DBFOT</mat-option>
            <mat-option value="HAM">HAM</mat-option>
          </mat-select>
          <mat-error
            *ngIf="indianSpecificForm.get('contractType')?.hasError('required')"
          >
            Required
          </mat-error>
        </mat-form-field>
      </div>

      <h3>Dispute Resolution Mechanism</h3>
      <div class="form-row">
        <div class="half-width">
          <mat-label>Arbitration Setup</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="arbitration" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Conciliation Committee</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="conciliation" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Dispute Review Board</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="disputeBoard" />
          </mat-form-field>
        </div>
      </div>

      <h3>Local Content Requirements</h3>
      <div class="form-row">
        <div class="half-width">
          <mat-label>Make in India Compliance</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="makeInIndia" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>MSME Participation</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="msmeParticipation" />
          </mat-form-field>
        </div>
      </div>

      <h3>Maintenance Period</h3>
      <div class="form-row">
        <div class="half-width">
          <mat-label>Defect Liability Period</mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="defectLiability" />
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Routine Maintenance Requirements</mat-label>

          <mat-form-field appearance="outline">
            <textarea matInput formControlName="routineMaintenance"></textarea>
          </mat-form-field>
        </div>
        <div class="half-width">
          <mat-label>Performance-based Maintenance</mat-label>

          <mat-form-field class="full-width" appearance="outline">
            <textarea
              matInput
              formControlName="performanceMaintenance"
            ></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="form-actions">
        <button mat-button matStepperPrevious>Back</button>
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          [disabled]="!indianSpecificForm.valid"
        >
          Next
        </button>
      </div>
    </form> -->
  </mat-step>
  <mat-step [stepControl]="documentationForm">
    <!-- <form [formGroup]="documentationForm">
      <ng-template matStepLabel>Documentation</ng-template>

      <div class="form-row">
        <div class="half-width">
          <mat-label>Contract Documents<span class="red">*</span></mat-label>
          <input
            type="file"
            (change)="uploadContractDocs($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
          <span>{{ documentationForm.value?.contractDocs }}</span>
       
        </div>
        <div class="half-width">
          <mat-label
            >Detailed Project Report (DPR)<span class="red">*</span></mat-label
          >
          <input
            type="file"
            (change)="uploadDPR($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        
          <span>{{ documentationForm.value?.dpr }}</span>
        </div>

        <div class="half-width">
          <mat-label>GFC Drawings</mat-label>
          <input
            type="file"
            (change)="uploadGFCDrawings($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        </div>

        <div class="half-width">
          <mat-label>Monthly Progress Reports</mat-label>
          <input
            type="file"
            (change)="uploadProgressReports($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        </div>

        <div class="half-width">
          <mat-label>Quality Assurance Plan</mat-label>
          <input
            type="file"
            (change)="uploadQAP($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        </div>

        <div class="half-width">
          <mat-label>Test Reports</mat-label>
          <input
            type="file"
            (change)="uploadTestReports($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        </div>

        <div class="half-width">
          <mat-label>As-built Drawings</mat-label>
          <input
            type="file"
            (change)="uploadAsBuiltDrawings($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        </div>

        <div class="half-width">
          <mat-label>O&M Manuals</mat-label>
          <input
            type="file"
            (change)="uploadOMManuals($event)"
            accept=".pdf,.doc,.docx,image/*"
            class="file-input"
          />
        </div>
      </div>

      <div class="form-actions">
        <button mat-button matStepperPrevious>Back</button>
        <button
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!documentationForm.valid"
        >
          {{ userId ? "Update" : "Submit" }}
        </button>
      </div>
    </form> -->
    <form [formGroup]="documentationForm">
  <ng-template matStepLabel>{{ 'doc.step_label' | translate }}</ng-template>

  <div class="form-row">
    <div class="half-width">
      <mat-label>{{ 'doc.contract_docs' | translate }}<span class="red">*</span></mat-label>
      <input
        type="file"
        (change)="uploadContractDocs($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
      <span>{{ documentationForm.value?.contractDocs }}</span>
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.dpr' | translate }}<span class="red">*</span></mat-label>
      <input
        type="file"
        (change)="uploadDPR($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
      <span>{{ documentationForm.value?.dpr }}</span>
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.gfc_drawings' | translate }}</mat-label>
      <input
        type="file"
        (change)="uploadGFCDrawings($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.progress_reports' | translate }}</mat-label>
      <input
        type="file"
        (change)="uploadProgressReports($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.qap' | translate }}</mat-label>
      <input
        type="file"
        (change)="uploadQAP($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.test_reports' | translate }}</mat-label>
      <input
        type="file"
        (change)="uploadTestReports($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.as_built_drawings' | translate }}</mat-label>
      <input
        type="file"
        (change)="uploadAsBuiltDrawings($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
    </div>

    <div class="half-width">
      <mat-label>{{ 'doc.om_manuals' | translate }}</mat-label>
      <input
        type="file"
        (change)="uploadOMManuals($event)"
        accept=".pdf,.doc,.docx,image/*"
        class="file-input"
      />
    </div>
  </div>

  <div class="form-actions">
    <button mat-button matStepperPrevious>{{ 'button.back' | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSubmit()"
      [disabled]="!documentationForm.valid || (!userId && seatLimitReached)"
      [matTooltip]="(!userId && seatLimitReached) ? (seatBudget?.message || 'Seat limit reached') : ''"
    >
      {{ userId ? ('button.update' | translate) : ('button.submit' | translate) }}
    </button>
  </div>
</form>

  </mat-step>
</mat-horizontal-stepper>
